module.exports = __webpack_public_path__ + "static/media/alert.3e33d8af.svg";